import moment from 'moment';

export default class HotelBooking {

constructor(bookingRequest) {
		moment.locale('pt');
		this.pax = bookingRequest.pax;
		this.clientId = bookingRequest.clientId;
		this.cityId = bookingRequest.hotel.cityId;
		this.hotelId = bookingRequest.hotel.id;
		this.roomTypeId = bookingRequest.roomType.id;
		this.rooms = bookingRequest.rooms;
		this.checkin = bookingRequest.checkin;
		this.checkout = bookingRequest.checkout;
		this.obs = bookingRequest.obs;
		this.supplierId = bookingRequest.price.supplierId;
		this.priceId = bookingRequest.price.id || bookingRequest.price.priceId;
		this.price = bookingRequest.price.price;
		this.adultsQty = bookingRequest.adultsQty;
		this.chdAges = bookingRequest.chdAges;
		this.type = 'hotel';
	}

	buildGuestsWithRPH(rooms) {
		let RPH = 0;
		let guests = [];
		for (var room of rooms) {
			if(room.guests)
				for (var guest of room.guests) {
					guest.RPH=RPH;
					guests.push(guest);
					RPH++;
				}
		}
		return guests;
	};
}



// WEBPACK FOOTER //
// ./src/model/HotelBooking.js